import React from 'react';
import { useTranslation } from 'react-i18next';
import { TrendingUp, MapPin, Home, DollarSign } from 'lucide-react';

const InvestmentSection = () => {
  const { t } = useTranslation();
  
  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://images.pexels.com/photos/34447145/pexels-photo-34447145.jpeg)'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-[#003366]/95 to-[#0052CC]/90"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              {t('investment.title')}
            </h2>
            <p className="text-lg md:text-xl text-gray-200 leading-relaxed">
              {t('investment.subtitle')}
            </p>
          </div>

          {/* Stats Grid */}
          <div className="grid md:grid-cols-3 gap-8 mt-12">
            <div className="bg-white/10 backdrop-blur-md rounded-lg p-6 text-center border border-white/20">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-yellow-400 text-[#003366] rounded-full mb-4">
                <TrendingUp className="w-8 h-8" />
              </div>
              <p className="text-3xl font-bold text-white mb-2">{t('investment.features.growth.title')}</p>
              <p className="text-gray-200">{t('investment.features.growth.description')}</p>
            </div>

            <div className="bg-white/10 backdrop-blur-md rounded-lg p-6 text-center border border-white/20">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-yellow-400 text-[#003366] rounded-full mb-4">
                <MapPin className="w-8 h-8" />
              </div>
              <p className="text-3xl font-bold text-white mb-2">{t('investment.features.location.title')}</p>
              <p className="text-gray-200">{t('investment.features.location.description')}</p>
            </div>

            <div className="bg-white/10 backdrop-blur-md rounded-lg p-6 text-center border border-white/20">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-yellow-400 text-[#003366] rounded-full mb-4">
                <Home className="w-8 h-8" />
              </div>
              <p className="text-3xl font-bold text-white mb-2">{t('investment.features.delivery.title')}</p>
              <p className="text-gray-200">{t('investment.features.delivery.description')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvestmentSection;